import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./UserSlice";
import appSlice from "./AppSlice";
import addressSlice from "./AddressSlice";
import shopSlice from "./ShopSlice";
import cartSlice from "./CartSlice";
import orderSlice from "./OrderSlice";
import wholesaleSlice from "./WholesaleSlice";
import productSlice from "./ProductSlice";

const store = configureStore({
    reducer: {
        userSlice: userSlice.reducer,
        appSlice: appSlice.reducer,
        addressSlice: addressSlice.reducer,
        productSlice : productSlice.reducer,
        shopSlice: shopSlice.reducer,
        cartSlice: cartSlice.reducer,
        orderSlice: orderSlice.reducer,
        wholesaleSlice : wholesaleSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== "production", // ✅ Correct placement
})

export default store;